import FormattedMessage from 'I18n/components/FormattedMessage';
import { SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { jsx as _jsx } from "react/jsx-runtime";
export const PublicMerchCardTitle = ({
  card,
  productGroup
}) => {
  let titleContent;
  switch (card.productLevel) {
    case 'FREE':
      titleContent = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.merchCard.tierLabels.free"
      });
      break;
    case 'STARTER':
      titleContent = productGroup === 'FREE' ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.merchCard.tierLabels.starterFreeTools"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.merchCard.tierLabels.starter"
      });
      break;
    case 'PROFESSIONAL':
      titleContent = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.merchCard.tierLabels.professional"
      });
      break;
    case 'ENTERPRISE':
      titleContent = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.merchCard.tierLabels.enterprise"
      });
      break;
    default:
      titleContent = card.displayName;
  }
  return /*#__PURE__*/_jsx(SectionTitle, {
    children: titleContent
  });
};